<template>
  <el-form :model="form" ref="form" label-position="left" label-width="45px" class="category-custom-attr">
    <el-form-item
      v-for="(customAttr, customAttrIndex) in form.customAttrs"
      :key="customAttr._key"
      :label="`参数${customAttrIndex + 1}`"
      :prop="`customAttrs.${customAttrIndex}.attrKey`"
      :rules="{
        validator: validateCustomAttr(customAttr),
        trigger: 'blur'
      }">
      <div class="customAttrRow">
        <el-select
          :value="-1">
          <el-option
            label="自定义参数名"
            :value="-1"></el-option>
        </el-select>
        <el-input
          v-model="customAttr.attrKey"
          placeholder="请输入参数名"
          clearable></el-input>
        <el-input
          v-model="customAttr.attrValue"
          placeholder="请输入参数值"
          clearable></el-input>
        <el-button
          type="info"
          icon="el-icon-delete"
          @click="removeCustomAttr(customAttrIndex)"></el-button>
      </div>
    </el-form-item>
    <el-form-item
      label-width="0px"
      v-show="form.customAttrs.length < 20">
      <el-button style="padding: 0;" type="link" icon="el-icon-plus" @click="addCustomAttr">添加新参数</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'wxxdCp',
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      required: true
    }
  },
  data() {
    return {
      form: {
        customAttrs: []
      },
      self_key: 99,
    }
  },
  watch: {
    values: {
      immediate: true,
      handler(v) {
        this.initCustomAttrs(v)
      }
    }
  },
  methods: {
    async method_getData() {
      try {
        await this.$refs.form.validate()
        return _.cloneDeep(this.form.customAttrs).map(item => {
          delete item._key
          return item;
        })
      } catch (error) {
        return false
      }
    },
    initCustomAttrs(values = []) {
      let _values = _.cloneDeep(values);
      if (_values.length) {
        _values.forEach(v => {
          v._key = this.self_key++
        })
        this.form.customAttrs = _values  
      }
    },
    validateCustomAttr(attr) {
      return (value, rule, callback) => {
        const attrKeyLen = attr.attrKey.length;
        const attrValueLen = attr.attrValue.length;
        if (attrKeyLen < 1 || attrKeyLen > 10) {
          callback(new Error(`参数名：最少1个、最多支持10个字`))
          return;
        }
        if (attrValueLen < 1 || attrValueLen > 50) {
          callback(new Error(`参数值：最少1个、最多支持50个字`))
          return;
        }
        callback()
      }
    },
    removeCustomAttr(index) {
      this.form.customAttrs.splice(index, 1);
    },
    addCustomAttr() {
      let newCustomAttr = {
        attrKey: '',
        attrValue: '',
        _key: this.self_key++
      }
      this.form.customAttrs.push(newCustomAttr);
    }
  }
}
</script>

<style lang="scss" scoped>
.category-custom-attr {
  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
}
.customAttrRow {
  display: flex;
  align-items: center;
  ::v-deep .el-input {
    width: 180px;
  }
  & > * + * {
    margin-left: 10px;
  }
}
</style>